/**
 * Patch payload for endpoint /api/users/{domain}/updateGuest
 */
export class DeleteUserRequest {
    constructor(
        userIds: string[],
        usingAdminRole: boolean,
        adminJustification: string
    ) {
        this.userIds = userIds;
        this.usingAdminRole = usingAdminRole;
        this.adminJustification = adminJustification;
    }
    userIds: string[] = [];
    usingAdminRole: boolean = false;
    adminJustification: string = '';
}